import { connect } from "react-redux";
import { setEnableAutomatedSendModalOpen, setConnectedService } from "../../Header/actions/creators";
import EnableAutomatedSendModal from "./EnableAutomatedSendModal";

const mapStateToProps = (state) => ({
  show: state.tdpDetailsReducer.isEnableAutomatedSendModalOpen,
  clients: state.tdpPeopleReducer.people?.listing_clients,
  clientRoles: state.tdpPeopleReducer.completeRoleList || [],
  listingUuid: state.tdpDetailsReducer.uuid,
  closeDate: state.tdpDatesReducer.dates?.close_date_milestone?.date,
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(setEnableAutomatedSendModalOpen(false)),
  setConnectedService: (connectedService) => dispatch(setConnectedService(connectedService)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnableAutomatedSendModal);
